import common from "./common.json";
import studio from "./studio.json";
import studioAutomations from "./studioAutomations.json";
import artEditor from "./artEditor.json";
import shell from "./shell.json";
import fragments from "./fragments.json";
import banking from "./banking.json";
import chat from "./chat.json";
import community from "./community.json";
import settings from "./settings.json";
import integrations from "./integrations.json";
import mentoringPrograms from "./mentoringPrograms.json";
import content from "./content.json";
import dashboard from "./dashboard.json";
import member from "./member.json";
import contentModals from "./contentModals.json";
import formsModals from "./formsModals.json";
import groupModals from "./groupModals.json";
import memberModals from "./memberModals.json";

// One namespace per JSON file. Keep this list identical across pt/en/es.
const resources = {
  studio,
  studioAutomations,
  artEditor,
  common,
  shell,
  fragments,
  banking,
  chat,
  community,
  settings,
  integrations,
  mentoringPrograms,
  content,
  dashboard,
  member,
  contentModals,
  formsModals,
  groupModals,
  memberModals,
};

export default resources;
